module.exports = __webpack_public_path__ + "static/bg-banner-cc-new-901bf13407456aab0ae6ae350c044303.png";